var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.3335,
    y: 2.66669,
    width: 13.3333,
    height: 10.6667,
    rx: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83524 8.0488C9.17407 8.51162 8.84349 8.74303 8.4839 8.83266C8.16627 8.91184 7.83406 8.91184 7.51643 8.83266C7.15684 8.74303 6.82625 8.51162 6.16508 8.0488L1.3335 4.66669C1.3335 3.56212 2.22893 2.66669 3.3335 2.66669H12.6668C13.7714 2.66669 14.6668 3.56212 14.6668 4.66669L9.83524 8.0488Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/IconMail.2126f69fd643591de2fdac7cdd348456.svg";
export { ForwardRef as ReactComponent };